import { createAsyncThunk } from '@reduxjs/toolkit';
import { _creditsPerGb } from '@custom/Utils/constants/apiUrls';

const getCreditsPerGbApi = createAsyncThunk('getCreditsPerGbApi', async () => {
  try {
    const token = sessionStorage.getItem('token') || localStorage.getItem('token');
    let url = `${_creditsPerGb.getCreditPerGb}`
    let response = await fetch(url, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      // body: JSON.stringify({})
    })
    return await response.json()
  } catch (error) {
    return error;
  }
});

export default getCreditsPerGbApi;
